import { FinancialDocumentExtended } from "@common/types/financialDocument";
import {
    ResizableHandle,
    ResizablePanel,
    ResizablePanelGroup,
} from "@design-system/ResizablePanels/ResizablePanels";
import { useDefaultLayout } from "react-resizable-panels";
import { FinancialDocumentPreview } from "../documents/FinancialDocumentDetails/FinancialDocumentPreview";
import { ImporterDataPreview } from "./ImporterDataPreview";
import styles from "./ImporterPage.module.scss";

interface Props {
    financialDocument: FinancialDocumentExtended;
}

export const ImporterDocumentPreview: React.FC<Props> = ({
    financialDocument,
}) => {
    const { defaultLayout, onLayoutChanged } = useDefaultLayout({
        groupId: "importer-review-panel-group-v2",
        storage: localStorage,
    });

    return (
        <section className={styles.preview}>
            <ResizablePanelGroup
                orientation="horizontal"
                defaultLayout={defaultLayout}
                onLayoutChanged={onLayoutChanged}
            >
                <ResizablePanel
                    defaultSize="50%"
                    minSize="25%"
                    maxSize="75%"
                    id="importer-doc-preview-panel"
                >
                    <FinancialDocumentPreview
                        financialDocument={financialDocument}
                        compact
                        noPadding
                    />
                </ResizablePanel>
                <ResizableHandle />
                <ResizablePanel
                    defaultSize="50%"
                    minSize="25%"
                    maxSize="75%"
                    id="importer-spreadsheet-panel"
                >
                    <div className={styles.dataPreview}>
                        <ImporterDataPreview
                            financialDocument={financialDocument}
                        />
                    </div>
                </ResizablePanel>
            </ResizablePanelGroup>
        </section>
    );
};
